var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":'Descargar Reportes',"classes":"col-lg-5"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"body",attrs:{"slot":"body"},slot:"body"},[_c('DownloadReportsView')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }